import { Drawer } from 'antd';
import type { DrawerProps } from 'antd';
import { useMergeSemantic } from 'antd/es/_util/hooks/useMergeSemantic';
import { useResponsiveDrawer, type ResponsiveDrawerVariant } from '@shared/hooks/useResponsiveDrawer';

interface ResponsiveDrawerProps extends DrawerProps {
  variant?: ResponsiveDrawerVariant;
}

export function ResponsiveDrawer({
  variant = 'details',
  size,
  width,
  placement,
  styles,
  ...rest
}: ResponsiveDrawerProps) {
  const config = useResponsiveDrawer({ variant });

  const legacyWidth = typeof width === 'number' ? width : undefined;
  const finalSize = size ?? legacyWidth ?? config.size;
  const finalPlacement = placement ?? config.placement;

  const infoProps = {
    ...rest,
    size: finalSize,
    placement: finalPlacement,
  };

  const [, mergedStyles] = useMergeSemantic(
    [],
    [config.styles, styles],
    {
      props: infoProps,
    },
  );

  return (
    <Drawer
      size={finalSize}
      placement={finalPlacement}
      styles={mergedStyles}
      {...rest}
    />
  );
}

